import { FeatureName } from '../../graphql';

export interface Feature {
  id: string;
  name: FeatureName;
  enabled: Boolean;
  description: string;
}
